module.exports = __webpack_public_path__ + "img/infrastructure-12.567c707f.png";